<template>
  <div>
    <br/><br/>
    <h5 class="pageTitle">Nos commanditaires</h5>
    <p id="intro">
      Encouragez nos annonceurs, certains nous réservent de bons rabais !<br/>
      <span style="color:#b1661b">Yves Blouin</span>, responsable de la publicité
      <br/>
      Téléphone : 418-622-4243,
      <br/>
      <a href="mailto:yblouin33@hotmail.com">Courriel</a>
    </p>

    <b-row v-for="sponsor in sponsors" :key="sponsor.id">
      <b-col v-if="sponsor.photoFull || sponsor.photo">
        <img
            :src="sponsor.photoFull ? sponsor.photoFull.url : sponsor.photo.url"
            class="img-fluid"
            :alt="sponsor.name"
        />
      </b-col>
      <b-col>
        <span style="font-size:14px; color:#b1661b">{{sponsor.name}}</span>
        <vue-markdown
            :source="sponsor.description"
            :anchor-attributes="{target: '_blank'}"
        />
      </b-col>
      <div class="separateur"></div>
    </b-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import SponsorsMixin from '@/components/Layout/Sponsors.mixin';

  export default {
    name: 'Commanditaires',
    mixins: [ SponsorsMixin ],
    mounted() {
      this.fetchConfigs();
    },
    methods: {
      ...mapActions('config', {
        fetchConfigs: 'fetchConfigs'
      })
    }
  };
</script>

<style scoped>
  #intro {
    font-size: 14px;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  #corps {
    font-size: 12px;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .layout_droite a:link {
    font-size: 14px;
    text-align: center;
    margin-right: 20px;
  }

  .separateur {
    border-bottom: 4px #ebebeb solid; /* gris */
    margin-bottom: 40px;
  }

  .commanditaires td {
    vertical-align: top;
  }

  .commanditaires p {
    text-align: center;
  }
</style>
